import { render, staticRenderFns } from "./AlmoxarifadoList.vue?vue&type=template&id=1f2889f6"
import script from "./AlmoxarifadoList.vue?vue&type=script&lang=js"
export * from "./AlmoxarifadoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports